module.exports = __webpack_public_path__ + "img/logo.b3b5dc7c.png";